<grid-virtual-scroll-viewport class="main-grid">
  <ng-container *gridVirtualFor="let rows of folderListDataSource; itemMinWidth: minWidth; itemMaxWidth: maxWidth; minGap: minGap;">
    @for (item of rows; track item) {
      <li class="columns">
        <folder-card [folder]="item" (goToFolder)="goToFolder.emit($event)"></folder-card>
      </li>
    }
  </ng-container>
</grid-virtual-scroll-viewport>
